import { c as _c } from "react/compiler-runtime";
import { BeamerProvider as AdminUiBeamerProvider } from '@newfront-insurance/admin-ui';
import type { JSX } from 'react';
import { AuthProvider } from './auth';
import { getConfig } from '@/config';
export function BeamerProvider() {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = getConfig();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    BEAMER
  } = t0;
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AdminUiBeamerProvider config={BEAMER} authProvider={AuthProvider} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
}